module.exports = __webpack_public_path__ + "media/images/plans/kaoawase/main-0d8ebb319cadc9a76865d001c46c979e.jpg";